module.exports = __webpack_public_path__ + "img/icon-mail.b3b28c79.svg";